/* eslint no-use-before-define: 0 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Translation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { each, intersectionWith, isArray } from 'lodash';
import { STANDARD_REFERENCE_NUMBERS } from '../constants';
export default class TextFilter extends Component {
    constructor(props) {
        super(props);
        this.onChange = (event) => {
            const newValue = event.target.value;
            if (this.state.text !== newValue) {
                this.setState({
                    text: newValue,
                });
            }
        };
        this.handleClearFilter = () => {
            this.setState({ filterItems: [], text: '' }, () => {
                this.props.filterChangedCallback();
            });
        };
        this.handleBulkFilter = (colId) => {
            const value = this.state.text;
            const filterItems = [];
            if (value) {
                // Build a unique array of filter item objects
                const items = value.replace(/\n/g, ',').split(',');
                const unique = {};
                each(items, (item) => {
                    item = item.trim();
                    if (item && item !== '' && !unique[item]) {
                        unique[item] = true;
                        const filter = {
                            [colId]: item.toUpperCase(),
                        };
                        filterItems.push(filter);
                    }
                });
                if (filterItems.length > 0) {
                    const text = this.makeText(filterItems);
                    this.setState({ filterItems, text }, () => {
                        this.props.filterChangedCallback();
                    });
                }
            }
        };
        /*
         * makeText is a helper function used to changed the state value of text
         * in particuliar to make it new line
         * @params {Object} filterItems
         * @returns {String} newline seperated values of filters
         */
        this.makeText = (filterItems) => {
            let str = '';
            filterItems.forEach((filter) => {
                const value = filter[this.props.column.colId] || '';
                if (value !== '')
                    str += value.toString() + '\n';
            });
            return str;
        };
        this.state = {
            text: '',
            filterItems: [],
        };
    }
    getModel() {
        const { filterItems } = this.state;
        return { value: filterItems };
    }
    setModel(model) {
        const filterItems = model ? model.value : [];
        let text = '';
        if (filterItems.length > 0) {
            text = filterItems
                .filter((item) => {
                return Object.keys(item).length > 0;
            })
                .map((item) => {
                var _a;
                const key = Object.keys(item)[0];
                return (_a = item[key]) === null || _a === void 0 ? void 0 : _a.toUpperCase();
            })
                .join(',');
        }
        this.setState({
            filterItems,
            text,
        });
    }
    doesFilterPass(params) {
        const { filterItems } = this.state;
        let columnId = this.props.column.colId;
        if (STANDARD_REFERENCE_NUMBERS.includes(columnId)) {
            columnId = 'reference_numbers';
        }
        const filterValues = filterItems.map((item) => (item[columnId] || '').toLowerCase());
        let columnValue = params.node.data[columnId] || '';
        if (isArray(columnValue)) {
            const values = columnValue.map((item) => item.value.toLowerCase());
            return intersectionWith(filterValues, values, (filterMatch, value) => value.includes(filterMatch)).length > 0;
        }
        columnValue = columnValue.toLowerCase();
        return (filterValues.filter((match) => {
            return columnValue.includes(match);
        }).length > 0);
    }
    isFilterActive() {
        return (this.state.filterItems || []).length > 0;
    }
    afterGuiAttached() {
        this.focus();
    }
    focus() {
        window.setTimeout(() => {
            const container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }
    getColumnTitle(column) {
        switch (column) {
            case 'equipment_id':
                return { localizationSlug: 'EQUIPMENTS' };
            case 'shipment_id':
                return { localizationSlug: 'SHIPMENT', count: 2 };
            case 'reference_numbers':
                return { localizationSlug: 'REFERENCE_NUMBERS' };
            case 'delivery_order':
                return { localizationSlug: 'DELIVERY_ORDER' };
            case 'gate_dropoff':
                return { localizationSlug: 'GATE_DROPOFF' };
            case 'gate_pickup':
                return { localizationSlug: 'GATE_PICKUP' };
            case 'house_bill_number':
                return { localizationSlug: 'HOUSE_BILL_NUMBER' };
            case 'isa':
                return { localizationSlug: 'ISA' };
            case 'master_bol':
                return { localizationSlug: 'MASTER_BOL' };
            case 'mg_load_id':
                return { localizationSlug: 'MG_LOAD_ID' };
            case 'mo_number':
                return { localizationSlug: 'MO_NUMBER' };
            case 'pu_number':
                return { localizationSlug: 'PU_NUMBER' };
            case 'seal_number':
                return { localizationSlug: 'SEAL_NUMBER' };
            case 'tracking_id':
                return { localizationSlug: 'TRACKING_ID' };
            case 'truck_order':
                return { localizationSlug: 'TRUCK_ORDER' };
            case 'VRID':
                return { localizationSlug: 'VRID' };
            case 'work_order_number':
                return { localizationSlug: 'WORK_ORDER_NUMBER' };
            case 'booking_number':
                return { localizationSlug: 'BOOKING_NUMBER' };
            default:
                return { localizationSlug: 'STATUSES' };
        }
    }
    render() {
        const columnTitle = this.getColumnTitle(this.props.column.colId);
        return ((React.createElement("div", { "data-testid": "div-15646119", className: "px-4 py-5 sm:p-6" },
            React.createElement("label", { "data-testid": "label-83e935f1", className: "mb-1 form-label" },
                React.createElement(Translation, null, (t) => (React.createElement(React.Fragment, null, t('ADD_COMMA_OR_NEW_LINE', {
                    column: columnTitle.count
                        ? t(columnTitle.localizationSlug, {
                            count: columnTitle.count,
                        })
                        : t(columnTitle.localizationSlug),
                }))))),
            React.createElement("textarea", { "data-testid": "textarea-5b4418a2", rows: 5, ref: "input", value: this.state.text, onChange: this.onChange, className: "form-field" }),
            React.createElement("div", { "data-testid": "div-f141d3e4", className: "flex justify-between mt-4" },
                React.createElement("button", { "data-testid": "button-be197cb9", className: "button button-secondary", onClick: () => this.handleClearFilter(this.props.column.colId) },
                    React.createElement(Translation, null, (t) => React.createElement(React.Fragment, null, titleize(t('CLEAR'))))),
                React.createElement("button", { "data-testid": "button-892cb566", className: "button button-green", onClick: () => this.handleBulkFilter(this.props.column.colId) },
                    React.createElement(Translation, null, (t) => React.createElement(React.Fragment, null, titleize(t('ADD')))))))));
    }
}
